import { RowMenu } from '@components/RowMenu';
import { RowMenuItem } from '@components/RowMenuItem';
import { ILoading } from '@hooks/useLoading';
import { IMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { Divider } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import EditIcon from '@material-ui/icons/Edit';
import { IContratoCliente } from '@model/ContratoCliente';
import { EnumContratoClienteStatus } from '@model/ContratoClienteStatus';
import { useContratoClienteService } from '@services/ContratoClienteService';
import React from 'react';
import HistoryIcon from '@material-ui/icons/History';
import RestorePageIcon from '@material-ui/icons/RestorePage';

export type ContratoMenuProps = {
    menu: IMenu
    contratoCliente: IContratoCliente
    cancelarModal: IModalWindow
    reativarModal: IModalWindow
    editarModal: IModalWindow
    atividadeModal: IModalWindow
    commandLoading: ILoading
}

export function ContratoMenu ({ contratoCliente, menu, cancelarModal, reativarModal, editarModal, atividadeModal, commandLoading }: ContratoMenuProps) {
    const contratoClienteService = useContratoClienteService();
    const message = useMessage();
    

    const handleGerarSegundaVia = React.useCallback(() => {
        if (!commandLoading.isLoading) {
            commandLoading.start();
            contratoClienteService.gerarSegundaVia(contratoCliente.contratoClienteId)
                .catch(message.showBlobException)
                .finally(commandLoading.stop);
        }

    }, [commandLoading, contratoCliente.contratoClienteId, contratoClienteService, message.showBlobException]);

    return (
        <RowMenu menu={menu}>
            <RowMenuItem
                key={0}
                icon={<CloudDownloadIcon />}
                text="Gerar Segunda Via de Contrato"
                onClick={menu.handleItemClick(handleGerarSegundaVia)}
            />

            <Divider />

            {
                contratoCliente.contratoClienteStatusId === EnumContratoClienteStatus.Ativo && (
                    <RowMenuItem 
                        key={1}
                        icon={<EditIcon />}
                        text="Editar Contrato"
                        onClick={menu.handleItemClick(editarModal.open)} 
                    />
                )
            }

            {
                (contratoCliente.contratoClienteStatusId === EnumContratoClienteStatus.Ativo || contratoCliente.contratoClienteStatusId === EnumContratoClienteStatus.Bloqueado) && (
                    <RowMenuItem 
                        key={2}
                        icon={<CancelIcon />}
                        text="Cancelar Contrato"
                        onClick={menu.handleItemClick(cancelarModal.open)}
                    />
                )
            }

            {
                contratoCliente.contratoClienteStatusId !== EnumContratoClienteStatus.Ativo && (
                    <RowMenuItem 
                        key={2}
                        icon={<RestorePageIcon />}
                        text="Reativar Contrato"
                        onClick={menu.handleItemClick(reativarModal.open)}
                    />
                )
            }

            <Divider />

            <RowMenuItem 
                key={3} 
                onClick={menu.handleItemClick(atividadeModal.open)}
                text="Atividades"
                icon={<HistoryIcon />}
            />
        </RowMenu>
    )
}